import React, { useEffect } from 'react';
import { X, AlertCircle, CheckCircle } from 'lucide-react';

function Toast({ message, type = 'error', onDismiss, duration = 4000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onDismiss, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onDismiss]);

  const colors = {
    error: 'bg-red-600/90 border-red-500/50',
    success: 'bg-green-600/90 border-green-500/50',
    info: 'bg-gray-700/90 border-gray-600/50',
  };

  const Icon = type === 'error' ? AlertCircle : CheckCircle;

  return (
    <div className={`fixed top-4 left-4 right-4 z-[100] flex items-center gap-3 px-4 py-3 rounded-xl border backdrop-blur-sm shadow-lg animate-slide-down ${colors[type] || colors.info}`}>
      <Icon className="w-5 h-5 text-white flex-shrink-0" />
      <p className="text-white text-sm flex-1">{message}</p>
      <button onClick={onDismiss} className="p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0">
        <X className="w-4 h-4 text-white" />
      </button>
    </div>
  );
}

export default Toast;
